import { API_URLS, getApiUrl } from '../Utils/apiURLConfiguration';
import GWRApiClient from './GWRApiClient';

const createIdListToDelete = allRecentSeachIds => {
  let idsList = '';
  allRecentSeachIds.forEach((item, index) => {
    if (index + 1 === allRecentSeachIds.length) {
      idsList += 'id=' + item;
    } else {
      idsList += 'id=' + item + '&';
    }
  });
  return idsList;
};

/**
 * Concrete implementation for the User Account endpoints on Tioga
 *
 * @class UserAccountApiClient
 * @extends {GWRApiClient}
 */
export default class UserAccountApiClient extends GWRApiClient {
  constructor(version = '', token = '') {
    let apiVersion = version !== '' ? version : `v1`;
    const urlAux = getApiUrl(API_URLS.REACT_APP_USERACCOUNT_ENDPOINT_TIOGA, apiVersion);
    super(urlAux, token);
  }

  /**
   * @function
   * Get user information based on token
   */
  async getUser(request) {
    const urlRequest = `${this.url}/User`;
    let response = await super.getApiCallAuth(urlRequest, request.queryParams);
    return response;
  }
  /**
   * @function
   * Get user loyalty balance and offers information based on token
   */
  async getUserUpdatedPointsAndOffers() {
    const urlRequest = `${this.url}/user/loyalty/balance`;
    let request = await super.getApiCallAuth(urlRequest);
    return request;
  }

  /**
   * @function
   * Get user point history information based on token and page
   * @param {requestObject: {page: number}} requestObject
   */
  async fetchUserPointsHistory(requestObject) {
    const urlRequest = `${this.url}/user/loyalty/history`;
    let request = await super.getApiCallAuth(urlRequest, requestObject?.queryParams);
    return request;
  }

  /**
   * @function
   * Update User Funnel Depth for the booking funnel
   * @param {object} request
   */
  async updateFunnelDepth(request) {
    const urlRequest = `${this.url}/funnel-depth`;
    return await super.postApiCallAuth(urlRequest, request);
  }

  /**
   * @function
   * Get all recent searches for the user
   * @param {object} request
   */
  async getAllRecentSearches() {
    const urlRequest = `${this.url}/room/searches`;
    return await super.getApiCallAuth(urlRequest);
  }

  /**
   * @function
   * Delete all recent searches for the user
   * @param {object} request
   */
  async deleteRecentSearchesAll(recentSearchesList) {
    const allRecentSeachIds = recentSearchesList.map(item => {
      return item.id;
    });
    const urlRequest = `${this.url}/room/searches?` + createIdListToDelete(allRecentSeachIds);
    return await super.deleteApiCallAuth(urlRequest);
  }

  /**
   * @function
   * Delete by id recent searches for the user
   * @param {object} request
   */
  async deleteRecentSearchById(recentSearchId) {
    const urlRequest = `${this.url}/room/searches?id=` + recentSearchId;
    return await super.deleteApiCallAuth(urlRequest);
  }

  /**
   * @function
   * Update user settings for my profile and my preferences pages
   * @param requestObject
   */
  async updateUserSettings(requestObject) {
    const urlRequest = `${this.url}/user`;
    let request = await super.patchApiCallAuth(urlRequest, requestObject);
    return request;
  }

  async sendReferralEmail(request) {
    const urlRequest = `${this.url}/user/loyalty/send-referral-email`;
    let response = await super.postApiCallAuth(urlRequest, request.queryParams);
    return response;
  }

  /**
   * @funtion
   *  Saves Lead generator form
   * @param  {object} user
   */
  async createLeadGenUser(user) {
    const urlRequest = `${this.url}/user/leadgen`;
    let request = await super.postApiCallAuth(urlRequest, user);
    return request;
  }

  async submitForgottenPasswordEmail(email, callbackUrl) {
    const urlRequest = `${this.url}/forgot-password`;
    let requestObject = {
      Email: email,
      Url: callbackUrl
    };
    let request = await super.postApiCallAuth(urlRequest, requestObject);
    return request;
  }

  async accountUnlock(email, resetToken) {
    const urlRequest = `${this.url}/unlock-account`;

    const requestObject = {
      Email: email,
      Token: resetToken
    };

    let request = super.postApiCallAuth(urlRequest, requestObject);

    return request;
  }

  async changePassword({ email, oldPassword, newPassword, resetToken }) {
    const urlRequest = `${this.url}/change-password`;

    let requestObject = {
      email,
      oldPassword,
      newPassword,
      resetToken
    };

    let request = super.postApiCallAuth(urlRequest, requestObject);

    return request;
  }

  /**
   * @funtion
   *  Whether email already taken
   * @param  {string}  emailaddress
   */
  async isEmailAlreadyTaken(email) {
    const urlRequest = `${this.url}/is-email-already-taken/?Email=${encodeURIComponent(email)}`;
    let request = await super.getApiCallAuth(urlRequest);
    return request;
  }

  /**
   * @function
   * Update LoyaltyOptIn flag to current user
   * @param {object} request
   */
  async loyaltyOptInUpdate() {
    const urlRequest = `${this.url}/user/loyalty/opt-in`;
    return await super.putApiCallAuth(urlRequest);
  }
}
